<template>
    <div>
        <v-row align="center" class="mb-4">
            <v-col :cols="3">
                <date-picker
                    v-model="dateData"
                    :label="$t('date')"
                    :clearable="false"
                    density="compact"
                    outlined
                    hide-details
                />
            </v-col>
            <v-col>
                <v-btn color="primary" class="mr-4" @click="resetFilters">{{ t('reset') }}</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="primary" @click="load">
                    {{ t('search') }}
                </v-btn>
            </v-col>
        </v-row>
        <div class="mb-4">
            <v-btn data-cy="create" @click="openCreateModal">
                {{ $t('create') }}
            </v-btn>
        </div>
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="isLoading"
            color="primary"
            density="compact"
            hide-default-footer
            class="elevation-1"
        >
            <template v-slot:item.currencyCode="{item}">
                <span class="text-link" @click="edit(item)">{{ item.currencyCode }}</span>
            </template>
        </v-data-table>
        <EditExchangeRateModal v-model="createRateModal" :selected-rate="selectedRate" @update="load" />
    </div>
</template>

<script setup lang="ts">
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import EditExchangeRateModal from '@/components/account/exchangeRates/EditExchangeRateModal.vue'
    import {format} from 'date-fns'

    const app = useNuxtApp()
    const {t} = useI18n()

    const headers: ComputedRef<{title: string; key: string; align?: string}[]> = computed(() => {
        return [
            {title: t('currency'), key: 'currencyCode', align: 'start'},
            {title: t('rate'), key: 'rate', align: 'end'},
            {title: t('factor'), key: 'factor', align: 'end'},
            {title: t('date'), key: 'date', align: 'center'},
        ]
    })

    const isLoading = ref<boolean>(false)
    const createRateModal = ref<boolean>(false)
    const dateData = ref<string>(format(new Date(), 'yyyy-MM-dd'))
    const items = ref<any[]>([])
    const selectedRate = ref<any>(null)

    onMounted(() => {
        load()
    })

    function resetFilters(): void {
        dateData.value = format(new Date(), 'yyyy-MM-dd')
        load()
    }

    function openCreateModal(): void {
        selectedRate.value = null
        createRateModal.value = true
    }

    async function load(): Promise<void> {
        try {
            isLoading.value = true
            const {manualExchangeRates} = await app.$api.manualExchangeRates.get({date: dateData.value})

            items.value = manualExchangeRates
        } catch (e) {
            console.error(e)
        } finally {
            isLoading.value = false
        }
    }

    function edit(item): void {
        selectedRate.value = item
        createRateModal.value = true
    }
</script>
